import React from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/dialogs/account/DialogAccount.style';
//Mui components
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import CopyIcon from '@mui/icons-material/FileCopy';
import IconButton from '@mui/material/IconButton';
// Locales
import translate from 'locales/i18n';
// Actions
import AlertAction from 'actions/AlertAction';

const ModuleDisplay = ({ moduleInfos, moduleSites }) => {
    const classes = useStyles();

    const copyCodeToClipboard = text => {
        navigator.clipboard.writeText(text);
        AlertAction.open('success', translate.i18n('SUCCESS_COPY'), 'top-right');
    };

    const renderSites = () => <div className={classes.moduleContainer}>
        <p className={classes.text}>Il y a {moduleSites.length} sites associés</p>
        {moduleSites.map(s =>
            <div key={s.id}>
                <Chip avatar={<Avatar alt={s.name} src={`https://www.google.com/s2/favicons?domain=${s.url}`} />}
                    label={s.name ? s.name : s.url}
                    onDelete={() => copyCodeToClipboard(s.name)}
                    deleteIcon={<CopyIcon />}
                    onClick={() => window.open(s.url, '_blank').focus()}
                    className={classes.chip}
                />
            </div>)}
    </div>;

    const renderInfos = () => <div className={classes.moduleContainer}>
        {Object.keys(moduleInfos).map(i =>
            <div key={i}>
                {Array.isArray(moduleInfos[i]) ?
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {i.toUpperCase() + ' : '}
                        {moduleInfos[i].map((m, index) => <div key={index}>{m} <IconButton onClick={() => copyCodeToClipboard(m)}> <CopyIcon className={classes.copyIcon} /></IconButton> </div>)}
                    </div>
                    :
                    <div className={classes.text}>
                        {`${i.toUpperCase()} : ${moduleInfos[i]}`}
                    </div>
                }
            </div>)
        }
    </div>;

    return <>
        {moduleInfos && renderInfos()}
        {moduleSites && Array.isArray(moduleSites) && renderSites()}
    </>;
};

ModuleDisplay.propTypes = {
    moduleInfos: PropTypes.object,
    moduleSites: PropTypes.array
};

export default ModuleDisplay;
